import React from 'react';
import { styled } from '@linaria/react';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { OfferLayoutBaseProps, OfferLayoutLoadingProps } from '.';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1fa0byd",
  propsAsIs: false
});
const BodyWrapper = /*#__PURE__*/styled('div')({
  name: "BodyWrapper",
  class: "b31g9y3",
  propsAsIs: false
});
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "hetkkl8",
  propsAsIs: false
});
const CTAWrapper = /*#__PURE__*/styled('div')({
  name: "CTAWrapper",
  class: "c1m8yejj",
  propsAsIs: false
});
const SkeletonWrapper = /*#__PURE__*/styled('div')({
  name: "SkeletonWrapper",
  class: "s17v5vkb",
  propsAsIs: false
});
export const PrimaryDefaultLayout: React.FC<OfferLayoutBaseProps | OfferLayoutLoadingProps> = ({
  priceComponent,
  isLoading,
  providerLogoComponent,
  ctaComponent,
  roomLabelsComponent,
  tagComponent,
  dataId
}) => {
  if (isLoading) return <SkeletonWrapper>
        <SkeletonLoader width={58} height={32} />
        <SkeletonLoader width={85} height={20} marginTop={4} />
        <SkeletonLoader width={201} height={34} marginTop={8} />
      </SkeletonWrapper>;
  return <Wrapper data-id={dataId}>
      <HeaderWrapper>{tagComponent}</HeaderWrapper>
      <BodyWrapper>
        <ContentWrapper paddingX="s200">
          {priceComponent}
          {providerLogoComponent}
          {roomLabelsComponent}
        </ContentWrapper>
        <CTAWrapper>{ctaComponent}</CTAWrapper>
      </BodyWrapper>
    </Wrapper>;
};

require("./PrimaryDefaultLayout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PrimaryDefaultLayout.tsx");